var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgBeamWeapon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 79,
  height: 32,
  viewBox: "0 0 79 32",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M59.776 13.824q.544 0 .944.4t.4.976q0 .544-.4.944t-.944.4H4.096v-2.72zm7.968 1.408 6.24 4.448-7.648-.064 2.4 7.264-6.144-4.544-2.304 7.296-2.304-7.296-6.176 4.544 2.432-7.264.256-.768h5.376q1.504 0 2.576-1.072T63.52 15.2t-1.072-2.576-2.576-1.072h-5.376l-.256-.704-2.432-7.296 6.176 4.576L60.288.8l2.304 7.328 6.144-4.576-2.4 7.296 7.648-.064zm-26.976 4.384v-.768h13.728v.768zm8.192-8.064v-.768h5.536v.768zm-14.656 0v-.768h10.208v.768zm-7.456 0v-.768h2.56v.768zm-7.328 0v-.768h1.056v.768zm-5.92 0v-.768h1.056v.768zm17.76 8.064v-.768h4.096v.768zm-8.608 0v-.768h.928v.768z"
})));
const Memo = /*#__PURE__*/memo(SvgBeamWeapon);
export default Memo;